import { Button } from '../../shared-components/Button'
import { useScreenTracking } from '../../shared-hooks/useScreenTracking'
import { SignupCard } from './SignupCard'
import { SignupStep } from './SignupFlow'

type SessionPickerSegueProps = {
  setSignupStep: (step: SignupStep) => void
}

export const SessionPickerSegue = ({
  setSignupStep,
}: SessionPickerSegueProps): JSX.Element => {
  useScreenTracking(
    'SessionPickerSegueView',
    'View session picker segue screen'
  )

  return (
    <SignupCard
      heading='Select the days you want your pay protected and start your free trial'
      subheading="Let us know which days you plan on driving. There is no penalty for not driving during a day you select, but you won't qualify for your protection for that day. You can edit, add and remove days at any time."
    >
      <Button
        type='button'
        onClick={() => setSignupStep(SignupStep.SessionPicker)}
      >
        Continue
      </Button>
    </SignupCard>
  )
}
